import { Box } from '@mui/material';
import HashLink from 'components/HashLink';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import Scrollspy from 'react-scrollspy';
import SVGInline from 'react-svg-inline';

import logo from '../../../../../App/components/Header/promoter-ninja.svg';
import logoReverse from '../../images/promoter-ninja-reverse.svg';

import {
  navBrandSx,
  navContainerSx,
  navListSx,
  navLogoReverseSx,
  navLogoSx,
  navMobileMenuOpenSx,
  navbarSx,
} from '../../homeSsrStyles';

const navToggleSx = inverse => ({
  display: { lg: 'none' },
  border: 'none',
  bgcolor: 'transparent',
  p: '9px 10px',
  mt: 1,
  mr: 2,
  flex: '0 0 auto',
});

const navIconBarSx = inverse => ({
  display: 'block',
  width: 22,
  height: 2,
  borderRadius: 1,
  bgcolor: inverse ? '#000' : '#fff',
  my: 0.5,
});

function Nav({ inverse = false }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <Box component="nav" sx={navbarSx(inverse)}>
      <Box sx={navContainerSx}>
        <Box sx={navBrandSx}>
          <Link to="/">
            <Box sx={navLogoReverseSx(inverse)}>
              <SVGInline svg={logoReverse} />
            </Box>
            <Box sx={navLogoSx(inverse)}>
              <SVGInline svg={logo} />
            </Box>
          </Link>
        </Box>
        <Box
          component="button"
          type="button"
          sx={navToggleSx(inverse)}
          aria-expanded={mobileOpen}
          aria-controls="home-nav-menu"
          onClick={() => setMobileOpen(open => !open)}
        >
          <Box sx={navIconBarSx(inverse)} />
          <Box sx={navIconBarSx(inverse)} />
          <Box sx={navIconBarSx(inverse)} />
        </Box>
        <Box
          component={Scrollspy}
          id="home-nav-menu"
          items={['sec-home', 'sec-features', 'sec-product']}
          currentClassName="is-current"
          offset={-105}
          onClick={e => {
            if (e.target.closest('a')) {
              setMobileOpen(false);
            }
          }}
          sx={[
            navListSx(inverse),
            {
              display: { xs: mobileOpen ? 'flex' : 'none', lg: 'flex' },
              flexDirection: { xs: 'column', lg: 'row' },
              alignItems: { xs: 'stretch', lg: 'center' },
            },
            mobileOpen && navMobileMenuOpenSx,
          ]}
        >
          <li>
            <HashLink smooth to={{ hash: 'sec-home-a' }}>
              <FormattedMessage id="Nav.Home" defaultMessage="Home" />
            </HashLink>
          </li>
          <li>
            <HashLink smooth to={{ hash: 'sec-features-a' }}>
              <FormattedMessage id="Nav.Features" defaultMessage="Features" />
            </HashLink>
          </li>
          <li>
            <HashLink smooth to={{ hash: 'sec-product-a' }}>
              <FormattedMessage id="Nav.Product" defaultMessage="Product" />
            </HashLink>
          </li>
          <li>
            <Link to="/pricing">
              <FormattedMessage id="Nav.Pricing" defaultMessage="Pricing" />
            </Link>
          </li>
          <li>
            <Link to="/login">
              <FormattedMessage id="Nav.Login" defaultMessage="Login" />
            </Link>
          </li>
          <li>
            <Link to="/sign-up" className="cta">
              <FormattedMessage id="Nav.GetStarted" defaultMessage="Free trial" />
            </Link>
          </li>
        </Box>
      </Box>
    </Box>
  );
}

Nav.propTypes = {
  inverse: PropTypes.bool,
};

Nav.defaultProps = {
  inverse: false,
};

export default Nav;
